import { ESecondCategories } from '@/domains/investor/const/SecondCategories.enum'
import { EMainCategories } from '@/domains/investor/const/MainCategories.enum'
export { ITEMS_PER_PAGE } from '@/domains/investor/components/DataView/DataView.const'

export const REPORTS_CATEGORIES = [
  ESecondCategories.CURRENT_REPORT,
  ESecondCategories.YEAR_REPORT,
  ESecondCategories.HALF_YEAR_REPORT,
  ESecondCategories.QUARTER_REPORT,
  ESecondCategories.ARCHIVE,
  ESecondCategories.SIGNIFICANT_TRANSACTION,
  ESecondCategories.MERGER_OF_COMPANIES,
]

export const REPORTS_CATEGORIES_SCOPE = {
  mainCategories: EMainCategories.REPORT,
  allowedSecondCategories: REPORTS_CATEGORIES,
}
